module.exports = __webpack_public_path__ + "img/10004.c8f66590.png";